/**
 * EmployerLayout — gates the CXO dashboard to the EMPLOYER role and wraps
 * it in the EmployerShell. Mirrors PatientLayout, but for the corporate
 * CXO surface (no form-factor shells — it's a desktop-first analytics view).
 */

import { ProtectedRoute } from './ProtectedRoute';
import { EmployerShell } from './EmployerShell';

export function EmployerLayout({ children }: { children: React.ReactNode }) {
  return (
    <ProtectedRoute allowRoles={['EMPLOYER']} audienceLabel="employers">
      <EmployerShell>{children}</EmployerShell>
    </ProtectedRoute>
  );
}
